var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center spinner-container"},[_c('div',{staticClass:"spinner-border purpleText",attrs:{"role":"status"}},[_c('span',{staticClass:"visually-hidden-focusable"},[_vm._v("Loading...")])])])
}]

export { render, staticRenderFns }